import { PageViewEvent } from '@shopify/events';

function onDocumentReady(callback, options) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, options);
  } else {
    callback();
  }
}

onDocumentReady(
  function dispatchPageViewEvent() {
    const templateElement = document.querySelector('main[data-template]');
    const template = templateElement?.dataset.template || '';

    document.dispatchEvent(
      new PageViewEvent({
        page: {
          template,
          title: document.title,
          url: window.location.href,
        },
      })
    );
  },
  { once: true }
);
